import $ from 'jquery';

export default class StLoadMore {
  init(options){
    let self = this;
    this.defaults = {
        items: '.product_list_item',
        paginaton_sample: '.paginaton_sample',
        product_count_infinite: '.product_count_infinite',
        more: '.infinite-more-link',
        element: '.products.product_list',
        offset: 'bottom-in-view',
        loadingClass: 'infinite-loading',
        onAfterPageLoad: $.noop
    };
    this.options = $.extend({}, this.defaults, options)

    this.$more = $(this.options.more);
    this.$container = $(this.options.element);
    this.start = this.$more.data('start');
    prestashop.on('updateProductList', (data) => {
        this.start = data.pagination.items_shown_from;
    });

    if(this.$container.length)
    {
        $('body').on(
            'click',
            this.options.more,
            function(event){
                event.preventDefault();
                self.load();
                return false;
            }
          );
    }
  };
  load(){
    this.$container = $(this.options.element);//update, it may change by clicking a paginations.
    //the same function in waypoints/lib/shortcuts/infinite.js
    this.$more.addClass('hidden');
    this.$container.parent().addClass(this.options.loadingClass)

    $.get($(this.options.more).attr('href'), {'from_infi':''}, $.proxy(function(data) {
        var $data = $($.parseHTML(data))
        var $newMore = $data.find(this.options.more)

        var $items = $data.find(this.options.items)
        if (!$items.length) {
          $items = $data.filter(this.options.items)
        }

        this.$container.append($items)
        //
        var $paginaton_sample = $data.find(this.options.paginaton_sample);
        if (!$paginaton_sample.length) {
          $paginaton_sample = $data.filter(this.options.paginaton_sample);
        }
        $(this.options.paginaton_sample).replaceWith($paginaton_sample);
        
        var $product_count_infinite = $data.find(this.options.product_count_infinite);
        if (!$product_count_infinite.length) {
          $product_count_infinite = $data.filter(this.options.product_count_infinite);
        }
        $product_count_infinite.find('span').html(this.start);
        $(this.options.product_count_infinite).replaceWith($product_count_infinite);
        //
        this.$container.parent().removeClass(this.options.loadingClass)

        if (!$newMore.length) {
          $newMore = $data.filter(this.options.more)
        }
        if ($newMore.length) {
          this.$more.replaceWith($newMore)
          this.$more = $newMore
          // this.waypoint = new Waypoint(this.options)
        }
        else {
          this.$more.remove()
        }

        this.options.onAfterPageLoad($items)
    }, this));
  };
}



// WEBPACK FOOTER //
// ./js/components/st-load-more.js


// WEBPACK FOOTER //
// ./js/components/st-load-more.js


// WEBPACK FOOTER //
// ./js/components/st-load-more.js


// WEBPACK FOOTER //
// ./js/components/st-load-more.js


// WEBPACK FOOTER //
// ./js/components/st-load-more.js


// WEBPACK FOOTER //
// ./js/components/st-load-more.js


// WEBPACK FOOTER //
// ./js/components/st-load-more.js


// WEBPACK FOOTER //
// ./js/components/st-load-more.js


// WEBPACK FOOTER //
// ./js/components/st-load-more.js


// WEBPACK FOOTER //
// ./js/components/st-load-more.js


// WEBPACK FOOTER //
// ./js/components/st-load-more.js


// WEBPACK FOOTER //
// ./js/components/st-load-more.js


// WEBPACK FOOTER //
// ./js/components/st-load-more.js


// WEBPACK FOOTER //
// ./js/components/st-load-more.js


// WEBPACK FOOTER //
// ./js/components/st-load-more.js


// WEBPACK FOOTER //
// ./js/components/st-load-more.js